import { createSlice } from "@reduxjs/toolkit";
import { ApiCall, ApiCallStatus } from "@myRedux/networkState";
import { RootState } from "@myRedux/store";
import { handleSliceRejectionDefault } from "@myRedux/handleSliceRejection";
import { putResourceFromRel } from "@myRedux/appAsyncThunkUtilities";
import { UserResource } from "@myRedux/user/userSlice";

export type UserPutResource = Omit<UserResource, 'password'>

const initialState = {
  status: ApiCallStatus.Idle,
} as ApiCall;

export const setUserDisplayNameAsync = putResourceFromRel<UserPutResource>(
  'user/putUser',
  'self_put'
);

export const userDisplayNameSlice = createSlice({
  name: 'userDisplayNameSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setUserDisplayNameAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(setUserDisplayNameAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
      })
      .addCase(setUserDisplayNameAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.error = action.payload;
        handleSliceRejectionDefault(action);
      })
  },
});

export const selectUserDisplayBame = (state: RootState) => state.user.userDisplayName;

export default userDisplayNameSlice.reducer;